import { Text } from '@vkontakte/vkui';
import React from 'react';
import { overquotaSafeVariantB, overquotaSafeVariantC } from 'reactApp/appHelpers/featuresHelpers/features/overquotaSafe';
import { renderComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { sendDwhDialog } from 'reactApp/modules/dwh/dwh.helpers';
import { moveToSafeRequest, trashbinSafeSetRestoreButtonVisible } from 'reactApp/modules/trashbin/trashbin.module';
import { store as reduxStore } from 'reactApp/store';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';
import { sendXray } from 'reactApp/utils/ga';

export const name = overquotaSafeVariantC ? 'files_to_safe_no_del' : 'files_to_safe';

interface ClearData {
    ids: string[];
    itemIds: string[];
    groupId: UserQuotaGroupId;
    size: number;
}

export const moveToSafe = (args: { place: 'trashbin'; size: number } | { place: 'cleaner'; clearData: ClearData }) => {
    renderComfirmationDialog({
        dataQAId: 'move-2safe-dialog',
        renderHeader: () => <>Освободить место</>,
        actionButtonText: 'Освободить',
        cancelButtonText: 'Оставить',
        buttons: [EButtonType.action, EButtonType.cancel],
        closeOnAction: true,
        smallButtons: true,
        isNegative: true,
        renderContent: () => (
            <Text style={{ fontSize: 18, lineHeight: '24px', width: '376px' }}>
                Вы действительно хотите удалить {args.place === 'trashbin' && args.size ? 'выбранные' : 'все'} файлы{' '}
                {args.place === 'trashbin' && !args.size ? 'в корзине' : ''}&nbsp;и&nbsp;освободить&nbsp;место?
            </Text>
        ),
        onCancel: () => {
            sendDwhDialog({ name, action: 'click', button_name: overquotaSafeVariantC ? 'cancel' : 'delete', place: args.place });
        },
        onAction: () => {
            sendDwhDialog({ name, action: 'click', button_name: 'confirm', place: args.place });
            reduxStore.dispatch(trashbinSafeSetRestoreButtonVisible(true));
            reduxStore.dispatch(moveToSafeRequest(args.place === 'trashbin' ? undefined : args.clearData));
        },
        onClose: () => sendDwhDialog({ name, action: 'close', place: args.place }),
        onShow: () => sendDwhDialog({ name, place: args.place }),
    });
};

export const sendXrayForSafeOpen = (isTrash, state = 'unk', isUserInOverquota = false) =>
    sendXray([
        `${isTrash ? 'trash' : 'clear'}-open`,
        overquotaSafeVariantB || overquotaSafeVariantC ? 'safeuser' : 'nonsafeuser',
        state,
        isUserInOverquota ? 'isoverq' : 'notoverq',
    ]);
